import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BreadCrumb from "./BreadCrumb";
import EventDetailsWrapper from "./EventDetailsWrapper";
import Footer from "../../../common/LayoutFooter";
import LayoutHeader from "../../../common/LayoutHeader";
import PageLoader from "../../../common/PageLoader";

const EventDetails = () => {
  const [evt, setEvent] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const { eventId } = useParams();

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events/${eventId}?populate[address][populate][0]=city&populate[contact][populate]=*&populate[listImage][populate]=*&populate[detailsImage][populate]=*&populate[thumbnailImage][populate]=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setEvent(data.data);
      } catch (error) {
        console.error("Error fetching event:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchEvent();
  }, [eventId]);

  if (isLoading) {
    return (
      <>
        <LayoutHeader />
        <PageLoader />
      </>
    );
  }

  if (!evt) {
    return (
      <>
        <LayoutHeader />
        <div className="hn-section">
          <p style={{ textAlign: "center", color: "var(--hn-gray5)" }}>Event not found.</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <div className="hypena-page-wrap">
      <LayoutHeader />
      <BreadCrumb evt={evt} />
      <EventDetailsWrapper evt={evt} />
      <Footer />
    </div>
  );
};

export default EventDetails;
